export const replaceStringByObjectKeys = (
  str: string,
  map: Record<string, string>,
) => {
  const pattern = new RegExp(
    Object.keys(map)
      .map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      .join('|'),
    'g',
  );

  return str.replace(pattern, (match) => map[match]);
};
